export default __webpack_public_path__ + "static/media/place-10.5bbcda1f.jpg";